import React from "react";
import styled from "styled-components";
import CheckedLink from "../../reusables/CheckedLink";

export default function DonateCard({ data }) {
	const { heading, description, linkTo, color } = data;

	return (
		<DonateCardContainer color={color}>
			{heading && description && (
				<>
					<h4>{heading}</h4>

					<p className="small text-justify">{description}</p>

					<CheckedLink link={linkTo}>Click to Donate</CheckedLink>
				</>
			)}
		</DonateCardContainer>
	);
}

const DonateCardContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 350px;
	height: fit-content !important;
	padding: 2.1rem;
	margin-bottom: 2.4rem;
	border-radius: 15px;
	background-color: ${(props) => (props.color ? props.color : "#edeaea")};

	h4 {
		margin-bottom: 0.9rem;
		font-weight: 600;
		text-transform: uppercase;
	}

	p {
		margin-bottom: 1.8rem;
	}

	a {
		color: #024ca3;
		font-size: 0.9rem;
		text-decoration: underline;
	}

	&.full-width {
		padding: 0.8rem;
		min-height: 11rem;

		h4 {
			font-weight: bold;
		}
	}

	@media (max-width: 768px) {
		width: 100%;

		min-height: 0;
		height: fit-content;

		p {
			margin-bottom: 1.5rem;
		}
	}
`;
